import {
  SPORTS_DATA,
  ODDS_DATA,
  BET_SLIP,
  BET_SLIP_CONTENT,
  SET_SESSION_DATA,
  SET_SESSION_ODDS,
  BET_MATCHES,
  USER_BETS,
  MATCH_BETS,
} from "./type";

const initialState = {
  betMatches: null,
  userBets: null,
  matchBets: null,
};

export default (state = initialState, actions) => {
  let { payload, type } = actions;
  switch (type) {
    case BET_MATCHES:
      return {
        ...state,
        betMatches: payload,
      };
    case USER_BETS:
      return {
        ...state,
        userBets: payload,
      };
    case MATCH_BETS:
      return {
        ...state,
        matchBets: payload,
      };
    default:
      return state;
  }
};
